import { Link } from "react-router-dom";
import { Seo } from "../components/seo/Seo";

export function NotFoundPage() {
  return (
    <>
      <Seo
        title="Pagina niet gevonden — Makers Hub"
        description="Deze pagina bestaat niet meer of heeft een nieuwe URL."
        path="/404"
        noindex
      />
      <article className="page page-404">
        <div className="container" style={{ textAlign: "center", padding: "80px 24px" }}>
          <span className="section-tag">404</span>
          <h1>Deze pagina bestaat niet</h1>
          <p className="lead">
            Misschien typo in de URL, misschien een oude link. Geen stress — kies een richting:
          </p>
          <div className="page-ctas" style={{ justifyContent: "center" }}>
            <Link to="/" className="btn btn-primary btn-lg">
              Terug naar home
            </Link>
            <Link to="/workshops" className="btn btn-ghost btn-lg">
              Bekijk workshops
            </Link>
          </div>
        </div>
      </article>
    </>
  );
}
